import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-2.5 left-2.5 z-50 max-w-[15.5rem]" data-id="element-135" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-136" data-mp="1175xy7vo5aih">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-xl border-2 border-naranja bg-oro p-2 text-noche shadow-xl ring-[3px] ring-noche" data-id="element-137" data-mp="116mjj1589497">
            <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-verde" data-id="element-138" data-mp="x515hcgyijxf">
              <CheckIcon size={12} className="text-white" strokeWidth={3.5} data-id="element-139" data-mp="s5ybqo6fg04r" />
            </span>
            <div className="min-w-0" data-id="element-140" data-mp="28jokw9celel9">
              <p className="text-xs font-bold leading-snug" data-id="element-141" data-mp="28imwl36dmvll">
                {buyer.name} compró el Mega Pack Lengua y Literatura 2026
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold leading-snug" data-id="element-142" data-mp="2ap30h91dqoan">
                <MapPinIcon size={10} className="flex-shrink-0 text-noche" data-id="element-143" data-mp="2fn4s4icvfvxq" />
                {buyer.city}, Argentina · hace {buyer.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="flex-shrink-0 rounded p-0.5 text-noche/70 transition-colors duration-150 ease-out hover:text-noche" data-id="element-144" data-mp="2pltzvib20009">
              <XIcon size={12} data-id="element-145" data-mp="1wv29x2kl07ld" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}